<template>
  <!-- <div :data-loadable-items="block.pageSize"> -->
  <div>
    <ul class="video-grid">
      <li v-for="(videoContent, index) in videosShowing" :key="videoContent.id" :class="'loadable ' + (index < limit) ? 'visible' : 'invisible' " >
        <figure v-if="videoContent && videoContent.type == 'video'" class="video-grid-item" @click="openModal(videoContent.id)">
          <img
            v-if="videoContent.images.length === 2"
            class="video-gallery-img"
            sizes="(min-width: 300px) 480px, (min-width: 1150px) 720px, 1280px"
            :src="videoContent.images[1].url"
            :srcset="videoContent.images[0].url + ' ' + videoContent.images[0].width + 'w, ' + videoContent.images[1].url + ' ' + videoContent.images[1].width + 'w'"
            :alt="videoContent.title"
          />
          <img
            v-else
            class="video-gallery-img"
            :src="videoContent.images[0].url"
            :alt="videoContent.itemTitle ? videoContent.title : videoContent.itemTitle"
          />
          <figcaption>
            <h3>{{ videoContent.itemTitle ? videoContent.title : videoContent.itemTitle }}</h3>
            <p class="duration">{{ videoContent.duration }}</p>
            <p class="description">{{ videoContent.description }}</p>
          </figcaption>
        </figure>
      </li>
    </ul>

    <div v-if="videosShowing.length <= allVideos.length" class="loadable load-more load-videos">
      <button 
        type="button" 
        class="button-loadmore"
        :data-total="allVideos.length"
        :data-limit="limit"
        @click="loadMore"
        data-container="video-grid"
      >
        <span class="txt">Load More</span>
        <span class="total-items">{{ '[' + (allVideos.length - currentLimit) + ']' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from '../event_bus.js';

export default {
  props:['videos', 'limit', 'video-player-options'],
  data: function() {
    return {
      isLoading: true,
      currentLimit: parseInt(this.limit),
    }
  },
  computed: {
    allVideos: function() {
      return JSON.parse(this.videos);
    },
    options: function() {
      return JSON.parse(this.videoPlayerOptions);
    },
    videosShowing: function() {
      return this.allVideos.slice(0, this.currentLimit);
    }
  },
  mounted() {
    const params = new URLSearchParams(location.search);
    const elementId = params.get("viewElement");

    if (elementId) {
      this.elementId = elementId;
      this.openModal(elementId, true);
    }
  },
  methods: {
    openModal: function(entryId, openOnUrlParams=false) {
      if (openOnUrlParams) {
        EventBus.$emit('open-modal', null, entryId, 'video', this.options);
      } else {
        this.$router.push({ path: `?viewElement=${entryId}` });
        EventBus.$emit('open-modal', null, entryId, 'video', this.options);
      }
    },
    loadMore: function() {
      this.currentLimit += parseInt(this.limit);
    },
    closeLoading: function() {
      this.isLoading = false;
    },
    cancelModal: function() {
      this.closeLoading();
      this.$emit('close-modal');
      this.showNotification('There was an issue loading the item');
    },
  }
}
</script>
